import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatTabsModule } from "@angular/material/tabs";
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from "@angular/material/icon";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { NgSelectModule } from "@ng-select/ng-select";
import { AgGridModule } from 'ag-grid-angular';

import { DirectivesModule } from "../common/directives/directives.module";
import { ProjectDetailsComponent } from "./project-details.component";
import { ThemeAllocationDailogComponent } from './project-details-dialog/theme-allocation-dailog/theme-allocation-dailog.component';
import { ProjectHeaderCardComponent } from './components/project-header-card/project-header-card.component';
import { ProjectInfoTabComponent } from './tabs/project-info-tab/project-info-tab.component';
import { ConsultantRatesTabComponent } from './tabs/consultant-rates-tab/consultant-rates-tab.component';
import { ProjectTasksTabComponent } from './tabs/project-tasks-tab/project-tasks-tab.component';
import { InvoicePrepaymentTabComponent } from './tabs/invoice-prepayment-tab/invoice-prepayment-tab.component';

@NgModule({
  declarations: [
    ProjectDetailsComponent,
    ThemeAllocationDailogComponent,
    ProjectHeaderCardComponent,
    ProjectInfoTabComponent,
    ConsultantRatesTabComponent,
    ProjectTasksTabComponent,
    InvoicePrepaymentTabComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    AgGridModule,
    DirectivesModule
  ],
  exports: [
    ProjectDetailsComponent,
    NgSelectModule
  ],
  schemas: [
    NO_ERRORS_SCHEMA,
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class ProjectDetailsModule {}